// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import Axios from 'Axios'
// import VueAxios from 'vue-axios'

//引入
import Goods from  './components/Goods/Goods'
import Ratings from  './components/Ratings/Ratings'
import Seller from  './components/Seller/Seller'



Vue.config.productionTip = false

//安裝使用VueRouter
Vue.use(VueRouter)

// Vue.use(VueAxios, Axios)

//如果在其他組件中使用axios命令，須改回Vue原型屬性
// Vue.propType.$axios = VueAxios
Vue.prototype.$axios = Axios

// 2. 定义路由
// 每个路由应该映射一个组件。 其中"component" 可以是
// 通过 Vue.extend() 创建的组件构造器，
// 或者，只是一个组件配置对象。
// 我们晚点再讨论嵌套路由。
const routes = [
  { path: '/', component: Goods },//重定向
  { path: '/goods', component: Goods },
  { path: '/ratings', component: Ratings },
  { path: '/seller', component: Seller }
]


// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
  routes, // (缩写) 相当于 routes: routes
  linkActiveClass:'active'//選中後的樣式，默認值為"router-link-exact-active"
})




/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',


  // 4. 创建和挂载根实例。
  // 记得要通过 router 配置参数注入路由，
  // 从而让整个应用都有路由功能
  router

})



// WEBPACK FOOTER //
// ./src/main.js